import React, { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useNavigation, useBasket, useCommerceSFRAAPI } from 'msp-integrations'
import { AlertBox, Icons, Button } from 'msp-components'
import { OrderActionProps } from '@/pages/account/AccountOrders/AccountOrderDetail/OrderActions/OrderActions.types'
import translations from './OrderReorderAction.constants'
import * as S from './OrderReorderAction.styles'

const OrderReorderAction = ({
  order,
  isProcessing,
  setIsProcessing = () => {}
}: OrderActionProps) => {
  const { formatMessage } = useIntl()
  const basket = useBasket()
  const navigate = useNavigation()
  const confirmBoxRef = useRef<AlertBox>()
  const SFRAClient = useCommerceSFRAAPI()
  const confirmAction = () => {
    const payload = {
      orderNo: order.orderNo
    }

    setIsProcessing(true)
    confirmBoxRef?.current.closeAlert()

    SFRAClient?.Order?.reOrder({ body: payload })
      .then(async (res: any) => {
        if (!res.error) {
          await basket.getOrCreateBasket()
          setIsProcessing(false)
          navigate('/cart')
        } else {
          setIsProcessing(false)
        }
      })
      .catch(() => {
        setIsProcessing(false)
      })
  }

  return (
    <>
      <Button
        className={S.ActionButton}
        variant='outline'
        type='secondary'
        isDisabled={isProcessing}
        onClick={() => confirmBoxRef?.current.showAlert()}
      >
        {formatMessage(translations.reOrder)}
      </Button>
      <AlertBox
        ref={confirmBoxRef}
        type='standard'
        headlineColor={S.ConfirmationHeadline}
        title={formatMessage(translations.orderReOrderTitle)}
        closeButtonIcon={<Icons iconName='Close' size='base' color='#000' />}
      >
        <div
          className={`${S.ConfirmationDescription} ${S.ConfirmationHeadline}`}
        >
          {formatMessage(translations.orderReOrderDescription)}
        </div>

        <div className={S.ConfirmationButtonsWrapper}>
          <Button
            type={'secondary'}
            variant='outline'
            className={S.ConfirmationCancelButton}
            onClick={() => confirmBoxRef?.current.closeAlert()}
          >
            {formatMessage(translations.orderReOrderCancel)}
          </Button>
          <Button type='secondary' onClick={() => confirmAction()}>
            {formatMessage(translations.orderReOrderConfirm)}
          </Button>
        </div>
      </AlertBox>
    </>
  )
}

export default OrderReorderAction
